import React from 'react';
import ReactDOM from 'react-dom/client';
import LandingPage from "./LandingPage";
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('landingpage'));
root.render(
  <React.StrictMode>
      <BrowserRouter>
    <LandingPage/>
      </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
